const Panzoom = require('@panzoom/panzoom/dist/panzoom');

setTimeout(function () {
    // Do something after 1 second 

    var parentHeight = $('.js-popin-zoom').height();
    var parentWidth = $('.js-popin-zoom').width();
    var naturalWidth = $('.panzoom .image-zoomable').width();
    var naturalHeight = $('.panzoom .image-zoomable').height();

    var i = 0, r = 0;
    if (parentWidth / parentHeight > naturalWidth / naturalHeight) {
        i = parentWidth
        r = parentWidth / naturalWidth * naturalHeight
    } else {
        i = parentHeight / naturalHeight * naturalWidth;
        r = parentHeight
    }
    if ( $(window).width() > 840 ) {
        $('.panzoom .image-zoomable').width(`${Math.ceil(i) + 16}px`);
        $('.panzoom .image-zoomable').height(`auto`);
    }else {
        $('.js-popin-zoom .panzoom').width(`${Math.ceil(r)}px`);
        $('.panzoom .image-zoomable').width(`${Math.ceil(r)}px`);
        $('.panzoom .image-zoomable').height(`${Math.ceil(r) *1.24}px`);
    }
    

    initImageZoom(1)
}, 1000);

function initImageZoom(initialRatio,n) {
    // calculate ratio;
    const elem = document.getElementById('panzoom-element');
    const zoomInButton = document.getElementById('zoom-in');
    const zoomOutButton = document.getElementById('zoom-out');
    const resetButton = document.getElementById('reset');
    const panzoom = Panzoom(elem, { contain: 'outside', startScale: initialRatio,startX :`${n}px` })
    const parent = elem.parentElement

    // No function bind needed
    parent.addEventListener('wheel', panzoom.zoomWithWheel);
    zoomInButton.addEventListener('click', panzoom.zoomIn)
    zoomOutButton.addEventListener('click', panzoom.zoomOut)
    resetButton.addEventListener('click', panzoom.reset);
}

function openZoomPopin() {
    $('.js-popin-zoom-modal').addClass('open');
    $('body').addClass('modal-open');
    initImageZoom(1,-160)
}
function closeZoomPopin() {
    initImageZoom(1)
    $('.js-popin-zoom-modal').removeClass('open');
    $('body').removeClass('modal-open');
    initImageZoom()
}
module.exports = {
    initZoom: function () {
        $(".primary-images img").each(function (i) {
            $(document).on('click', '.primary-images img', function(){
                var SelectImg = $(this).data("image-index");

                $(".panzoom img").each(function (i) {
                    if (SelectImg == $(this).data("image-index")) {
                        $(this).css('display', 'inline-block').addClass('active');
                    }
                    else {
                        $(this).hide().removeClass('active');
                    }
                });
                $(".btn-wrapp-zoom img").each(function (i) {
                    if (SelectImg == $(this).data("image-index")) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });
                openZoomPopin();
            });

        });
        $(".btn-wrapp-zoom img").each(function (i) {
            $(this).on('click', function () {
                $(this).addClass('active').siblings().removeClass('active');
                var SelectImg = $(this).data("image-index");
                $(".panzoom img").each(function (i) {
                    if (SelectImg == $(this).data("image-index")) {
                        $(this).css('display', 'inline-block').addClass('active');
                    }
                    else {
                        initImageZoom(1,-160)
                        $(this).hide().removeClass('active');
                    }
                });
            });
        });
        var NumberImageZoom = $('.panzoom img').length,
            ArrowSlider = $('.btn-wrapp-zoom');
        if (NumberImageZoom <= 1) {
            ArrowSlider.hide();
        }
        $('.btn-close').on('click', function () {
            $(".panzoom img").each(function (i) {
                $(this).removeClass('active');
            });
            closeZoomPopin(this)
        });
    }
}
